import { apiPost, apiPostFormData } from '@/api/api.ts'
import { IUser } from '@/api/user/getUsers.ts'

export interface IReqCreateUser {
    centerId: number
    name: string
    gender: number
    birthDate: string
    contact: string
    address: string
    addressLatitude: number
    addressLongitude: number
    primaryRelation?: string
    primaryContact?: string
    secondaryRelation?: string
    secondaryContact?: string
    tertiaryRelation?: string
    tertiaryContact?: string
    addressDetail?: string
    inspectorMemo?: string
    deviceSerial?: string
    file?: File
}

export const apiCreateUser = async (params: IReqCreateUser) => {
    // undefined/null 값 제거
    const cleanParams: Record<string, any> = {}
    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null) {
            cleanParams[key] = value
        }
    }

    // 파일이 있으면 FormData, 없으면 JSON으로 전송
    if (cleanParams.file) {
        return await apiPostFormData<IUser>(`/protectee`, cleanParams)
    } else {
        delete cleanParams.file
        return await apiPost<IUser>(`/protectee`, cleanParams)
    }
}
